/* tslint:disable */
/* eslint-disable */
/**
 * Calvin Risk API
 * TBD
 *
 * The version of the OpenAPI document: 6.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { AiModelTaskType } from './AiModelTaskType';
import { AiModelTaskTypeFromJSON, AiModelTaskTypeFromJSONTyped, AiModelTaskTypeToJSON } from './AiModelTaskType';
import type { AssessmentStatusCount } from './AssessmentStatusCount';
import {
  AssessmentStatusCountFromJSON,
  AssessmentStatusCountFromJSONTyped,
  AssessmentStatusCountToJSON,
} from './AssessmentStatusCount';
import type { DeploymentStatusCount } from './DeploymentStatusCount';
import {
  DeploymentStatusCountFromJSON,
  DeploymentStatusCountFromJSONTyped,
  DeploymentStatusCountToJSON,
} from './DeploymentStatusCount';

/**
 *
 * @export
 * @interface AiModelStatusCount
 */
export interface AiModelStatusCount {
  /**
   *
   * @type {AiModelTaskType}
   * @memberof AiModelStatusCount
   */
  taskTypeCount: AiModelTaskType;
  /**
   *
   * @type {{ [key: string]: number; }}
   * @memberof AiModelStatusCount
   */
  useCaseCount: { [key: string]: number };
  /**
   *
   * @type {DeploymentStatusCount}
   * @memberof AiModelStatusCount
   */
  deploymentStatusCount: DeploymentStatusCount;
  /**
   *
   * @type {AssessmentStatusCount}
   * @memberof AiModelStatusCount
   */
  assessmentStatusCount: AssessmentStatusCount;
}

/**
 * Check if a given object implements the AiModelStatusCount interface.
 */
export function instanceOfAiModelStatusCount(value: object): value is AiModelStatusCount {
  if (!('taskTypeCount' in value) || value['taskTypeCount'] === undefined) return false;
  if (!('useCaseCount' in value) || value['useCaseCount'] === undefined) return false;
  if (!('deploymentStatusCount' in value) || value['deploymentStatusCount'] === undefined) return false;
  if (!('assessmentStatusCount' in value) || value['assessmentStatusCount'] === undefined) return false;
  return true;
}

export function AiModelStatusCountFromJSON(json: any): AiModelStatusCount {
  return AiModelStatusCountFromJSONTyped(json, false);
}

export function AiModelStatusCountFromJSONTyped(json: any, ignoreDiscriminator: boolean): AiModelStatusCount {
  if (json == null) {
    return json;
  }
  return {
    taskTypeCount: AiModelTaskTypeFromJSON(json['task_type_count']),
    useCaseCount: json['use_case_count'],
    deploymentStatusCount: DeploymentStatusCountFromJSON(json['deployment_status_count']),
    assessmentStatusCount: AssessmentStatusCountFromJSON(json['assessment_status_count']),
  };
}

export function AiModelStatusCountToJSON(value?: AiModelStatusCount | null): any {
  if (value == null) {
    return value;
  }
  return {
    task_type_count: AiModelTaskTypeToJSON(value['taskTypeCount']),
    use_case_count: value['useCaseCount'],
    deployment_status_count: DeploymentStatusCountToJSON(value['deploymentStatusCount']),
    assessment_status_count: AssessmentStatusCountToJSON(value['assessmentStatusCount']),
  };
}
